module.exports = __webpack_public_path__ + "static/img/4tgimg.d501303.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4tgimg.jpg
// module id = m3X6
// module chunks = 2